var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokenWrapper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 53,
    viewBox: "0 0 47 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_132_2458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 53
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0026V39.0077L23.6526 51.5L45.3051 39.0077V14.0026L23.6526 1.5L2 14.0026Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_132_2458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0026V39.0077L23.6526 51.5L45.3051 39.0077V14.0026L23.6526 1.5L2 14.0026Z",
    fill: "white",
    stroke: "#AA7D50",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenWrapper);
export default __webpack_public_path__ + "static/media/token-wrapper.a49491fccfc15844da7cbed8f38e9546.svg";
export { ForwardRef as ReactComponent };